export default __webpack_public_path__ + "static/media/promotion-banner-one-desktop.5665c91e.png";